export default __webpack_public_path__ + "static/media/breast1.a6f17b76.jpg";